import { useEffect, useState } from 'react';

export const BREAKPOINTS = {
  mobile: 640,
} as const;

export default function useBreakpoint(mobileBreakpoint?: number) {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < (mobileBreakpoint || BREAKPOINTS.mobile),
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < (mobileBreakpoint || BREAKPOINTS.mobile));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { isMobile };
}
